// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1agir","location":"Header_location__2HazU"};